<script type="text/javascript">
	import { onMount } from 'svelte';
	onMount(async () => {
		document.title = "Все для - GTA 5, GTA San Andreas(САМП 0.3.7), CRMP Mobile";
		document.querySelector('meta[name="description"]').setAttribute("content", "");
	});
	import ArticleLink from "../ui/articleList/articleLink.svelte";
	let list = [];
	if (typeof global === "undefined") {

		//products = Array(50).fill({loading: true});
		if (window.clientContext.articlesListPageContents) list = window.clientContext.articlesListPageContents;
		else fetch("/api/articles/get").then(r=>r.json()).then(r=>list=r);
		console.log(window.clientContext.articlesListPageContents);
	}
	else{
		list = global.ssrContext.articlesListPageContents;
	}
	
</script>
<div class="articlesHeader">
	<svg width="20" height="30" viewBox="0 0 20 30" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M5.86019 6.9749H14.1639C14.4946 6.9749 14.7824 6.71158 14.7824 6.35641C14.7824 6.00123 14.5191 5.73792 14.1639 5.73792H5.86019C5.52951 5.73792 5.2417 6.00123 5.2417 6.35641C5.2417 6.71158 5.52339 6.9749 5.86019 6.9749Z" fill="#9862C5"/>
		<path d="M5.86029 11.7575H14.164C14.4947 11.7575 14.7825 11.4942 14.7825 11.139C14.7825 10.8083 14.5192 10.5205 14.164 10.5205H5.86029C5.52961 10.5205 5.2418 10.7838 5.2418 11.139C5.23567 11.4758 5.52349 11.7575 5.86029 11.7575Z" fill="#9862C5"/>
		<path d="M5.86019 16.5218H14.1639C14.4946 16.5218 14.7824 16.2585 14.7824 15.9033C14.7824 15.5481 14.5191 15.2848 14.1639 15.2848H5.86019C5.52951 15.2848 5.2417 15.5481 5.2417 15.9033C5.2417 16.2585 5.52339 16.5218 5.86019 16.5218Z" fill="#9862C5"/>
		<path d="M5.86019 21.2798H14.1639C14.4946 21.2798 14.7824 21.0165 14.7824 20.6613C14.7824 20.3307 14.5191 20.0428 14.1639 20.0428H5.86019C5.52951 20.0428 5.2417 20.3062 5.2417 20.6613C5.2417 21.0165 5.52339 21.2798 5.86019 21.2798Z" fill="#9862C5"/>
		<path d="M17.8566 0H2.14318C1.18789 0 0.404053 0.783833 0.404053 1.73913V28.2609C0.404053 29.2162 1.18789 30 2.14318 30H17.8566C18.8119 30 19.5957 29.2162 19.5957 28.2609V1.73913C19.5957 0.783833 18.8303 0 17.8566 0ZM10.2877 27.9241H9.74269C9.41201 27.9241 9.1242 27.6607 9.1242 27.3056C9.1242 26.9749 9.38752 26.6871 9.74269 26.6871H10.2877C10.6184 26.6871 10.9062 26.9504 10.9062 27.3056C10.8817 27.6363 10.6184 27.9241 10.2877 27.9241ZM17.1156 24.3295H2.88415V2.7128H17.1462L17.1156 24.3295Z" fill="#9862C5"/>
	</svg>
	<div>
		<h2>Статьи</h2>
	</div>
</div>
<ul class="articlesList">
	{#each list as article}
		<li><ArticleLink {...article}/></li>
	{/each}
</ul>

<style lang="scss">
	.articlesHeader{
		width: 100%;
		border-bottom: 1px solid rgba(255,255,255,.1);
		padding-bottom: 20px;
		display: flex;align-items: center;gap:10px;
		&>div>h2{
			padding:0;
			margin:0;
			font-family: 'Geometria';
			font-style: normal;
			font-weight: 500;
			font-size: 24px;
		}
	}
	.articlesList{
		list-style: none;
		padding:0;
		flex-wrap: wrap;
		display: flex;
		gap: 15px;
	}
</style>